import gql from "graphql-tag";

export const MY_TAX_CREATE_FOUR_CHILDREN_DECLARATION = gql`
  mutation createTaxDeclarationFourChildren(
    $dateOfDeclaration: Date!
    $isModifiedDeclaration: Boolean!
    $isEligible: Boolean!
    $permanentlyEntitled: Boolean!
    $notApplyFromMonth: String!
    $dependents: [TaxDeclarationFourChildrenDependentInput]
  ) {
    createTaxDeclarationFourChildren(
      dateOfDeclaration: $dateOfDeclaration
      isModifiedDeclaration: $isModifiedDeclaration
      isEligible: $isEligible
      permanentlyEntitled: $permanentlyEntitled
      notApplyFromMonth: $notApplyFromMonth
      dependents: $dependents
    ) {
      result
      messages
      tableId
    }
  }
`;
